import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Typography,
} from "@mui/material";
import React from "react";

export default function AssociatedCard({
  item,
  setEditedItem,
  setOpen2,
  setSelectedUser,
}) {
  return (
    <Card
      sx={{
        cursor: "pointer",
        boxShadow: 3,
        borderRadius: 2,
        backgroundColor: "#E9E9FF",
      }}
      onClick={() => setEditedItem(item)}
    >
      <CardContent sx={{ pb: 2 }}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Typography
              color="primary"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                fontWeight: 600,
              }}
            >
              {item?.name}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Typography
              variant="body2"
              fontWeight={500}
              fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
              sx={{ display: "inline", mr: 0.5 }}
            >
              User ID:
            </Typography>
            <Typography
              variant="body2"
              color="primary"
              fontWeight={500}
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                display: "inline",
              }}
            >
              {item?.loginId}
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                color="secondary"
                variant="contained"
                onClick={(e) => {
                  e.stopPropagation();
                  setOpen2(true);
                  setSelectedUser(item);
                }}
                sx={{
                  backgroundColor: "#01008B",
                  color: "#fff",
                  fontSize: "13px",
                  height: "23px",
                  fontWeight: 500,
                  borderRadius: "5px !important",
                  px: 3,
                  "&:hover": {
                    backgroundColor: "#01118A",
                  },
                }}
              >
                Scope
              </Button>
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
